import { useEffect, useState } from 'react'

export const PRINT_ACCORDION_PREFERENCE_KEY = 'printRecords.expandAllAccordions'

const readAccordionPreference = () => {
  if (typeof window === 'undefined') {
    return false
  }

  return localStorage.getItem(PRINT_ACCORDION_PREFERENCE_KEY) === 'true'
}

const useAccordionPreference = () => {
  const [expandAllAccordions, setExpandAllAccordions] = useState<boolean>(
    readAccordionPreference,
  )

  useEffect(() => {
    localStorage.setItem(
      PRINT_ACCORDION_PREFERENCE_KEY,
      String(expandAllAccordions),
    )
  }, [expandAllAccordions])

  return {
    expandAllAccordions,
    setExpandAllAccordions,
  }
}

export default useAccordionPreference
